/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO pro předmět daně z nemovitých věcí
 */
export interface PredmetDaneDto { 
    /**
     * Kód předmětu daně
     */
    kod?: string;
    /**
     * Zkrácený text předmětu daně pro zobrazení v select boxech
     */
    optionText?: string;
    /**
     * Popis předmětu daně
     */
    popis?: string;
}

